/**************************************************
 * Nombre:       BarraCell
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Collapse, Grid, Icon, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import logo from '../../Recursos/Logos/logo_color.svg'
import logo_solo from '../../Recursos/Logos/logo_solo_blanco.svg'
import {Menu, ShoppingCart} from '@mui/icons-material'
import {theme} from "../../Tema";
import {useNavigate} from "react-router";
import {useState} from "react";


const BarraCell = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 3, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                           <IconButton>
                               <Menu sx={{fill: theme.palette.primary.main}}/>
                           </IconButton>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 12, md: 6}} sx={{justifyContent: 'center'}}>
                            <img
                                onClick={() => navigate('/Home')}
                                src={logo} width={80} height={'auto'} style={{cursor: 'pointer'}}/>
                        </Grid>

                        <Grid container size={{xs: 3, sm: 12, md: 3}} sx={{justifyContent: 'flex-end'}}>
                            <IconButton>
                                <ShoppingCart sx={{fill: theme.palette.primary.main}}/>
                            </IconButton>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>



        </Grid>


    )

}
export default BarraCell

const CATEGORIAS = ['LENTES DE CONTACTO', 'GAFAS PARA HOMBRE', 'GAFAS PARA MUJER', 'GAFAS PARA NIÑO']